class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const quickFilter = document.querySelector('.quick-filter');
    if (quickFilter) {
      const quickFilterValues = quickFilter.querySelectorAll('.list-menu__item input');
      if (quickFilterValues) {
        quickFilterValues.forEach((quickValue) => {
          quickValue.addEventListener('change', this.triggerFilter.bind(this));
        });
      }
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const desktopCollection = document.querySelector('.collection-filter');
    const hasProductTypeFilter = searchParams.includes('filter.p.product_type');
    if (desktopCollection) {
      desktopCollection.classList.toggle('single-filter', hasProductTypeFilter);
    }
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      FacetFiltersForm.renderProductImageContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderProductImageContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductImageContainer(html) {
    document.getElementById('editorial-image-container').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('editorial-image-container').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop', '.quick-filter'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });
    FacetFiltersForm.toggleActiveFacets(false);
    
    const quickFilter = document.querySelector('.quick-filter');
    if (quickFilter) {
      const quickFilterValues = quickFilter.querySelectorAll('.list-menu__item input');
      if (quickFilterValues) {
        quickFilterValues.forEach((quickValue) => {
          quickValue.addEventListener('change', (event) => {
            const filterName = event.target.getAttribute('name');
            const filterValue = event.target.getAttribute('value')
            
            if (filterName === 'filter.p.product_type') {
              FacetFiltersForm.renderPage(`filter.p.product_type=${filterValue}`);
              document.querySelector('.facet-filter-desktop').classList.remove('open');
            } else {
              const inputFilter = document.querySelector(`menu-drawer facet-filters-form input[name="${filterName}"][value="${filterValue}"]`);
              inputFilter.click();
            }
          });
        })
      }
    }
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  triggerFilter(event) {
    const filterName = event.target.getAttribute('name');
    const filterValue = event.target.getAttribute('value')
    const inputFilter = document.querySelector(`menu-drawer facet-filters-form input[name="${filterName}"][value="${filterValue}"]`);
    inputFilter.click();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
window.addEventListener('DOMContentLoaded', () => {
  const searchParams = window.location.search.slice(1);
  const hasFilterParams = /(^|&)filter\.|(^|&)sort_by=/.test(searchParams);

  if (hasFilterParams) {
    const FacetFiltersFormEl = document.querySelector('facet-filters-form');
    if (FacetFiltersFormEl?.constructor?.renderPage) {
      FacetFiltersFormEl.constructor.renderPage(searchParams, null, false);
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const openLabel = document.querySelector('.facet-filter-desktop');
  const openFilterMobile = document.querySelector('.mobile-facets__open-wrapper');
  const cleanURL = window.location.pathname;

  if (!openLabel) return;

  openLabel.addEventListener('click', (e) => {
    e.preventDefault();

    document.querySelector('.mobile-facets__wrapper')?.classList.remove('open');
    openLabel.classList.add('open')
    history.replaceState({}, '', cleanURL);

    if (typeof FacetFiltersForm !== 'undefined') {
      FacetFiltersForm.toggleActiveFacets?.();
      FacetFiltersForm.renderPage?.('');
    }
  });

  openFilterMobile.addEventListener('click', (e) => {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    params.delete('filter.p.product_type');

    const mobileUrl = `${url.pathname}?${params.toString()}`;
    history.replaceState({}, '', mobileUrl);

    if (typeof FacetFiltersForm !== 'undefined') {
      FacetFiltersForm.toggleActiveFacets?.();
      FacetFiltersForm.renderPage?.(params.toString());
    }
  });
});

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.minRange = this.querySelector('.min-slider');
    this.maxRange = this.querySelector('.max-slider');
    this.minText  = this.querySelector('input[type="text"].input-min');
    this.maxText  = this.querySelector('input[type="text"].input-max');
    this.progress = this.querySelector('.slider-progress');

    this.minRange.addEventListener('input', () => this.onMinSliderChange());
    this.maxRange.addEventListener('input', () => this.onMaxSliderChange());
    this.minText .addEventListener('input', () => this.onMinTextChange());
    this.maxText .addEventListener('input', () => this.onMaxTextChange());
    [this.minText, this.maxText].forEach(inp =>
      inp.addEventListener('keydown', this.onKeyDown.bind(this))
    );

    this.updateProgress();
    this.updatePriceDisplay();
  }

  onMinSliderChange() {
    let min = +this.minRange.value;
    let max = +this.maxRange.value;

    if (min > max) {
      min = max;
      this.minRange.value = min;
    }
    this.minText.value = min;
    this.syncAttributes();
    this.updateProgress();
    this.updatePriceDisplay();
  }

  onMaxSliderChange() {
    let min = +this.minRange.value;
    let max = +this.maxRange.value;

    if (max < min) {
      max = min;
      this.maxRange.value = max;
    }
    this.maxText.value = max;
    this.syncAttributes();
    this.updateProgress();
    this.updatePriceDisplay();
  }

  onMinTextChange() {
    this.clampText(this.minText);
    const min = +this.minText.value || 0;
    const max = +this.maxText.value || +this.maxRange.max;

    if (min > max) {
      this.maxText.value  = min;
      this.maxRange.value = min;
    }
    this.minRange.value = min;
    this.syncAttributes();
    this.updateProgress();
  }

  onMaxTextChange() {
    this.clampText(this.maxText);
    const min = +this.minText.value || 0;
    const max = +this.maxText.value || +this.maxRange.max;

    if (max < min) {
      this.minText.value  = max;
      this.minRange.value = max;
    }
    this.maxRange.value = max;
    this.syncAttributes();
    this.updateProgress();
  }
  
  clampText(input) {
    let val = parseInt(input.value);
    const min = +input.dataset.min || 0;
    const max = +input.dataset.max || 10000;
    if (isNaN(val)) val = min;
  
    if (val < min) val = min;
    if (val > max) val = max;
  
    input.value = val;
  }

  syncAttributes() {
    this.minText.dataset.max = this.maxText.value || this.maxRange.max;
    this.maxText.dataset.min = this.minText.value || 0;
  }

  updateProgress() {
    const min = +this.minRange.value;
    const max = +this.maxRange.value;
    const rangeMax = +this.minRange.max;
    const left  = (min / rangeMax) * 100;
    const width = ((max - min) / rangeMax) * 100;
    this.progress.style.left  = left  + '%';
    this.progress.style.width = width + '%';
  }

  updatePriceDisplay() {
    const minDisplay = this.querySelector('.min-price');
    const maxDisplay = this.querySelector('.max-price');
    minDisplay.textContent = `$${this.minRange.value}`;
    maxDisplay.textContent = `$${this.maxRange.value}`;
  }

  onKeyDown(e) {
    if (e.metaKey) return;
    const ok = /[0-9]|\.|,|\s|Tab|Backspace|Enter|Arrow|Delete|Escape/.test(e.key);
    if (!ok) e.preventDefault();
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
class CustomSelect {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.button = wrapper.querySelector('.custom-select__button');
    this.optionsList = wrapper.querySelector('.custom-select__options');
    this.hiddenInput = wrapper.querySelector('#SortByHidden');
    this.options = wrapper.querySelectorAll('.custom-select__option');
    this.init();
  }

  init() {
    // Toggle dropdown on button click
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      this.toggleOptions();
    });

    // Handle option selection
    this.options.forEach((option) => {
      option.addEventListener('click', () => {
        this.selectOption(option);
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (event) => {
      if (!this.wrapper.contains(event.target)) {
        this.closeOptions();
      }
    });

    // Handle keyboard navigation
    this.wrapper.addEventListener('keydown', (event) => {
      this.handleKeyboard(event);
    });
  }

  toggleOptions() {
    const isExpanded = this.wrapper.getAttribute('aria-expanded') === 'true';
    this.wrapper.setAttribute('aria-expanded', !isExpanded);
    this.optionsList.hidden = isExpanded;
    if (!isExpanded) {
      this.options[0].focus();
    }
  }

  closeOptions() {
    this.wrapper.setAttribute('aria-expanded', 'false');
    this.optionsList.hidden = true;
  }

  selectOption(option) {
    const value = option.getAttribute('data-value');
    const label = option.textContent.trim();

    // Update hidden input value
    this.hiddenInput.value = value;

    // Update aria-selected
    this.options.forEach((opt) => opt.setAttribute('aria-selected', 'false'));
    option.setAttribute('aria-selected', 'true');

    // Close dropdown
    this.closeOptions();

    // Trigger form submission
    const form = this.wrapper.closest('form');
    if (form) {
      const facetFiltersForm = document.querySelector('facet-filters-form');
      if (facetFiltersForm) {
        const event = new Event('input', { bubbles: true });
        form.dispatchEvent(event); // Trigger debounced onSubmit
      }
    }
  }

  handleKeyboard(event) {
    const key = event.key;
    if (key === 'Enter' || key === ' ') {
      event.preventDefault();
      this.toggleOptions();
    } else if (key === 'Escape') {
      this.closeOptions();
      this.button.focus();
    } else if (key === 'ArrowDown' || key === 'ArrowUp') {
      event.preventDefault();
      const isExpanded = this.wrapper.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        const currentOption = document.activeElement.closest('.custom-select__option');
        let index = Array.from(this.options).indexOf(currentOption);
        if (key === 'ArrowDown') {
          index = (index + 1) % this.options.length;
        } else {
          index = (index - 1 + this.options.length) % this.options.length;
        }
        this.options[index].focus();
      }
    }
  }
}

// Initialize custom select
document.querySelectorAll('.custom-select-wrapper').forEach((wrapper) => {
  new CustomSelect(wrapper);
});